var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrain = function SvgTrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3c-4.42 0-8 .5-8 4v9.5C4 18.43 5.57 20 7.5 20l-1.15 1.15a.5.5 0 0 0 .36.85H17.3c.45 0 .67-.54.35-.85L16.5 20c1.93 0 3.5-1.57 3.5-3.5V7c0-3.5-3.58-4-8-4M7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18m3.5-6H6V7h5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m1.5-6h-5V7h5z"
  })));
};
export default SvgTrain;